export const getMarkersList = (facility, scale, geoUnit) => {
  let markers = geoUnit.type ? facility.filter((item) => item[geoUnit.type] == geoUnit.name) : [...facility];

  if (markers.length <= 1) return markers;

  let arrResult = [];
  let arrIntersected = [];
  const markerRadius = 700 / scale;

  while (markers.length) {
    const { lat: lat1, lng: lng1 } = markers[0];

    for (let i = markers.length - 1; i >= 1; i--) {
      const { lat: lat2, lng: lng2 } = markers[i];
      const distans = Math.sqrt((lat2 - lat1) ** 2 + (lng2 - lng1) ** 2);

      if (distans < markerRadius) {
        arrIntersected.push(markers[i]);
        markers.splice(i, 1);
      }
    }

    if (arrIntersected.length) {
      arrResult.push([markers[0], ...arrIntersected]);
      arrIntersected = [];
    } else {
      arrResult.push(markers[0]);
    }

    markers.splice(0, 1);
  }

  return arrResult;
};
